export const COLORS = {
  priorityBlue: {
    hex: '#0F083E',
    tailwind: 'slate-900'
  }
}
